import React, { useState, useEffect } from "react";
// import Img1 from "../../../assets/images/watch-product1.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import {
  useApplyCouponMutation,
  useGetCartDataQuery,
  useReduceCartQuantityMutation,
  useRemoveCartItemMutation,
  useUpdateCartQuantityMutation,
  useGetActiveShiipingOptionQuery
} from "../../../services/cartPageAPI";
import { useGetCartCountQuery } from "../../../services/cartPageAPI";
import { Link } from "react-router-dom";
import { useGetColorThemeQuery, useGusetCheckoutStatusDisplayQuery } from "../../../services/commonAPI";
import Loader from "../fullPageLoader";

function Products() {
  const { data, error, isLoading, refetch } = useGetCartDataQuery();
  const { data: activeShippingOption } = useGetActiveShiipingOptionQuery();
  //   const [updateQuantity, { isLoading: isUpdating }] =
  //     useUpdateCartQuantityMutation();
  const [updateQuantity] = useUpdateCartQuantityMutation();
  const [reduceQuantity] = useReduceCartQuantityMutation();
  const [removeCartItem] = useRemoveCartItemMutation();
  const [applyCoupon, { isLoading: isApplyingCoupon }] =
    useApplyCouponMutation();

  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();

  const { data: checkOutStatus } = useGusetCheckoutStatusDisplayQuery();

  const AccessToken = localStorage.getItem("access_token");
  const GuestCheckOutStatus = checkOutStatus?.data?.guest_checkout_enabled;

  const [cartItems, setCartItems] = useState([]);
  const [totals, setTotals] = useState({
    subtotal_main_price: 0,
    subtotal_selling_price: 0,
    total_discount: 0,
    total_amount: 0,
    total_items: 0,
    discount_percentage: 0,
  });

  const [cartId, setCartId] = useState(""); // Add state for cartId

  const [couponCode, setCouponCode] = useState("");
  const [message, setMessage] = useState(""); // State to store backend messages
  const [appliedCoupons, setAppliedCoupons] = useState([]); // State to store applied coupons
  const [guestCheckOut, setGuestCheckOut] = useState(false);
  const { refetch: refetchCartCountData } = useGetCartCountQuery();

  useEffect(() => {
    if (data?.success) {
      setCartItems(data.data);
      setTotals(data.totals);
      setAppliedCoupons(data.coupons || []); // Set applied coupons from the API response
      setCartId(data.cart_id); // Set cartId in state
      localStorage.setItem("cart_id", data.cart_id);
    }
  }, [data]);

  // Helper function to get available stock for a product
  const getAvailableStock = (product) => {
    if (!product?.attributes || product?.attributes?.length === 0) {
      return 0;
    }

    // For now, we'll use the stock from the first attribute
    // In future, this can be modified to handle variants
    const attribute = product.attributes[0];
    return attribute?.stock || 0;
  };

  // Helper function to check if product is out of stock
  const isOutOfStock = (product) => {
    const stock = getAvailableStock(product);
    return (
      stock === 0 || !product?.attributes || product?.attributes?.length === 0
    );
  };

  // Function to handle incrementing the quantity

  const handleIncrement = async (item) => {
    const availableStock = getAvailableStock(item.product);
    const newQuantity = item.quantity + 1;

    if (newQuantity <= availableStock) {
      try {
        await updateQuantity({
          product_id: item.product_id,
          quantity: 1,
        }).unwrap();
        // Refetch cart data to update the UI
        refetch();
      } catch (err) {
        console.error("Failed to update quantity:", err);
        alert("Failed to update quantity. Please try again.");
      }
    } else {
      alert("Cannot add more items. Stock limit reached.");
    }
  };

  const handleDecrement = async (item) => {
    if (item.quantity > 1) {
      try {
        await reduceQuantity({
          product_id: item.product_id,
        }).unwrap();
        // Refetch cart data to update the UI
        refetch();
      } catch (err) {
        console.error("Failed to update quantity:", err);
        alert("Failed to update quantity. Please try again.");
      }
    }
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  // Function to handle removing an item from the cart
  const handleRemoveItem = async (item) => {
    try {
      await removeCartItem({
        product_id: item.product_id,
      }).unwrap();
      // Refetch cart data to update the UI
      refetch();
      refetchCartCountData();
    } catch (err) {
      console.error("Failed to remove item:", err);
      alert("Failed to remove item. Please try again.");
    }
  };

  // Function to handle applying a coupon
  const handleApplyCoupon = async (e) => {
    e.preventDefault(); // Prevent form submission

    if (!couponCode) {
      alert("Please enter a coupon code.");
      return;
    }

    try {
      const response = await applyCoupon({
        coupon_code: couponCode,
      }).unwrap();
      setMessage(response.message); // Set the message from the backend
      setCouponCode(""); // Clear the input field
      refetch(); // Refetch cart data to update the UI
    } catch (err) {
      console.error("Failed to apply coupon:", err);
      setMessage(
        err.data?.message || "Failed to apply coupon. Please try again."
      );
    }
  };
  const handleGetGuestCheckoutEnable = () => {
    setGuestCheckOut(true);
  }

  useEffect(() => {
    localStorage.setItem("guestCheckOutEnable", guestCheckOut)
  }, [guestCheckOut])
  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load page content</p>;

  console.log("cartItems", cartItems)
  return (
    <div className="cart-page">
      <div className="container">
        <div className="cart-items">
          {cartItems.length > 0 ?
            (<div className="row">
              <div className="col-md-8 col-sm-12 col-lg-8">
                <div className="cart-table table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>PRODUCT</th>
                        <th>PRICE</th>
                        <th>QUANTITY</th>
                        <th>SUBTOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.map((item) => {
                        const availableStock = getAvailableStock(item?.product);
                        const variantCombination = item?.variant_details;


                        return (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <button
                                  onClick={() => handleRemoveItem(item)}
                                  style={{ border: "none", background: "none" }}
                                >
                                  <FontAwesomeIcon
                                    icon={faClose}
                                    style={{ marginRight: 8 }}
                                  />
                                </button>

                                <div>
                                  <img
                                    src={item?.product?.product_main_image_url_large}
                                    alt="cart-img"
                                    width={60}
                                    height={60}
                                    loading="lazy"
                                    className="cart-image"
                                  />
                                </div>
                                <div>
                                  <span style={{ marginLeft: 10 }}>
                                    {item?.product?.product_name}
                                    {variantCombination?.length > 0 && (
                                      <div style={{ fontSize: "13px", color: "gray", marginLeft: "10px" }}>
                                        {variantCombination.map((v, index) => (
                                          <div key={index}><b>{v.variant_attribute_name}</b> : {v.variant_value_name}</div>
                                        ))}
                                      </div>
                                    )}
                                  </span>

                                </div>
                              </div>
                            </td>
                            <td>${item?.product?.selling_price}</td>
                            <td>
                              <div className="quantity-selector">
                                <div>
                                  <button
                                    className="cart-counter-button"
                                    onClick={() => handleDecrement(item)}
                                    disabled={
                                      item.quantity <= 1 ||
                                      isOutOfStock(item?.product)
                                    }
                                  >
                                    -
                                  </button>
                                  <button
                                    className="cart-counter-button"
                                    onClick={() => handleDecrement(item)}
                                    disabled={
                                      item.quantity <= 1 ||
                                      isOutOfStock(item?.product)
                                    }
                                  >
                                    {item.quantity}
                                  </button>

                                  <button
                                    className="cart-counter-button"
                                    onClick={() => handleIncrement(item)}
                                    disabled={
                                      isOutOfStock(item?.product) ||
                                      item.quantity >= availableStock
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </td>
                            <td>${item?.line_total_selling_price}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div>
                  <form onSubmit={handleApplyCoupon}>
                    <input
                      type="text"
                      placeholder="Coupon Code"
                      value={couponCode}
                      onBeforeInput={(e) => {
                        const value = e.target.value + e.data;
                        const containsDisallowedChars = /[<>/"'`]/.test(e.data);
                        const containsScript = /script/i.test(value);
                        const containsUrl = /(https?:\/\/|www\.|\.com|\.net|\.org|\.io)/i.test(value);

                        if (containsDisallowedChars || containsScript || containsUrl) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pastedText = e.clipboardData.getData('text');
                        const containsDisallowed = /[<>/"'`]/.test(pastedText) ||
                          /script/i.test(pastedText) ||
                          /(https?:\/\/|www\.|\.com|\.net|\.org|\.io)/i.test(pastedText);

                        if (containsDisallowed) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        const sanitized = value
                          .replace(/[<>/"'`]/g, '')
                          .replace(/script/gi, '')
                          .replace(/(https?:\/\/|www\.|\.com|\.net|\.org|\.io)/gi, '');

                        setCouponCode(sanitized);
                      }}
                    />

                    <button
                      type="submit"
                      className="primary-button"
                      disabled={isApplyingCoupon}
                      style={{
                        backgroundColor:
                          colorthemeData?.color_themes?.[0]?.primary_color ||
                          "#a76d50",
                      }}
                    >
                      {isApplyingCoupon ? "Applying..." : "APPLY COUPON"}
                    </button>
                  </form>
                  {message && (
                    <div
                      className={`mt-2 text-start ${message.includes("successfully")
                        ? "text-success"
                        : "text-danger"
                        }`}
                    >
                      {message}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-4">
                <div className="proceed-to-checkout-div">
                  <h4>CART TOTAL</h4>
                  <div className="d-flex justify-space-between mb-4">
                    <div>Subtotal</div>
                    <div>${totals.subtotal_selling_price}</div>
                  </div>

                  {activeShippingOption?.data?.type === "fixed" && <div className="d-flex justify-space-between mb-4">
                    <div>Shipping Rate</div>
                    <div>${Math.round(activeShippingOption?.data?.amount)}</div>
                  </div>}

                  {activeShippingOption?.data?.type === "free" && <div className="d-flex justify-space-between mb-4">
                    <div>Free</div>
                    <div>$0</div>
                  </div>}

                  {appliedCoupons.length > 0 && (
                    <>
                      {/* <hr /> */}
                      <div>
                        <h6>Coupons Applied:</h6>
                        {appliedCoupons.map((coupon, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between"
                          >
                            <div>
                              {coupon.code}
                            </div>
                            <div>
                              {" "}
                              -$
                              {coupon.type === "percentage"
                                ? coupon.discount_amount
                                : coupon.discount_amount}
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  <hr className="border-top-total" />
                  <div className="d-flex justify-space-between">
                    <div><b>Total</b></div>
                    <div
                      className="grand-total"
                      style={{
                        color:
                          colorthemeData?.color_themes?.[0]?.primary_color ||
                          "#a76d50",
                      }}
                    >
                      ${totals.total_amount}
                    </div>
                  </div>

                  {/* <Link to={cartId ? `/checkout/${cartId}` : "#"}>
                  <button
                    className="primary-button w-100 mt-4"
                    style={{
                      backgroundColor:
                        colorthemeData?.color_themes?.[0]?.primary_color ||
                        "#a76d50",
                    }}
                  >
                    PROCEED TO CHECKOUT
                  </button>
                </Link> */}

                  {AccessToken || GuestCheckOutStatus === 1 ? (
                    <Link to={cartId ? `/checkout/${cartId}` : "#"}>
                      <button
                        className="primary-button w-100 mt-4"
                        style={{
                          backgroundColor:
                            colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                        }}
                      >
                        PROCEED TO CHECKOUT
                      </button>
                    </Link>
                  ) : (
                    <Link to="/register">
                      <button
                        className="primary-button w-100 mt-4"
                        onClick={handleGetGuestCheckoutEnable}
                        style={{
                          backgroundColor:
                            colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                        }}
                      >
                        REGISTER TO CHECKOUT
                      </button>
                    </Link>
                  )}

                </div>
              </div>
            </div>) : (<h3>No Items are in cart</h3>)}
        </div>
      </div>
    </div>
  );
}

export default Products;
